import React, { useEffect, useState } from 'react';

const SCREEN_MODES = {
    MOBILE: 'MOBILE',
    TABLET: 'TABLET',
    DESKTOP: 'DESKTOP'
};

const getScreenMode = () => {
    const { innerWidth } = window;
    if (innerWidth <= 600) {
        return SCREEN_MODES.MOBILE;
    }
    if (innerWidth < 1024) {
        return SCREEN_MODES.TABLET;
    }
    return SCREEN_MODES.DESKTOP;
};

const WithResizeScreen = WrappedComponent => {
    return props => {
        const [screenMode, setScreenMode] = useState(getScreenMode());

        const updateScreenMode = () => {
            setScreenMode(getScreenMode());
        };

        useEffect(() => {
            window.addEventListener('resize', updateScreenMode);
            window.addEventListener('orientationchange', updateScreenMode); // Deprecated, but still work on Mobile Safari
            if (screen && screen.orientation && screen.orientation.addEventListener) {
                screen.orientation.addEventListener('change', updateScreenMode); // Not work on Mobile Safari
            }

            return () => {
                window.removeEventListener('resize', updateScreenMode);
                window.removeEventListener('orientationchange', updateScreenMode);
                if (screen && screen.orientation && screen.orientation.removeEventListener) {
                    screen.orientation.removeEventListener('change', updateScreenMode);
                }
            };
        }, []);

        return <WrappedComponent {...props} screenMode={screenMode} />;
    };
};

export { SCREEN_MODES, getScreenMode };
export default WithResizeScreen;
